import { select } from '@ngneat/elf';
import { selectAllEntities } from '@ngneat/elf-entities';
import { createRequestDataSource } from '@ngneat/elf-requests';
import { auditOfferFollowUpStore } from './audit-offer-followUp.store';

export const getAuditOfferFollowUpDataSource = createRequestDataSource({
  store: auditOfferFollowUpStore,
  data$: () => auditOfferFollowUpStore.pipe(selectAllEntities()),
  requestKey: 'getAuditOfferFollowUp',
  dataKey: 'auditOfferFollowUp',
});


export const getAuditsOfferActivitiesDataSource = createRequestDataSource({
  store: auditOfferFollowUpStore,
  data$: () => auditOfferFollowUpStore.pipe(select((state) => state.activities)),
  requestKey: 'getAuditsOfferActivities',
  dataKey: 'auditsOfferActivities',
});

export const getAuditsProposalDetailsDataSource = createRequestDataSource({
  store: auditOfferFollowUpStore,
  data$: () => auditOfferFollowUpStore.pipe(select((state) => state.auditsProposalDetails)),
  requestKey: 'getAuditsProposalDetails',
  dataKey: 'auditsProposalDetails',
});

export const getAuditsOfferFromProposalDataSource = createRequestDataSource({
  store: auditOfferFollowUpStore,
  data$: () => auditOfferFollowUpStore.pipe(select((state) => state.allAuditsOfferFromProposal)),
  requestKey: 'getAuditsOfferFromProposal',
  dataKey: 'allAuditsOfferFromProposal',
});
